import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Handshake } from "@mui/icons-material";
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { CONTRACTS_ENDPOINT } from '../../../../consts';
import styles from './clientContracts.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import EntityReferenceLink from '../../../../components/ui/entityReference/entityReferenceLink.component';

export const ClientContracts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const canViewContracts = useHasPermission("settlement.view_contract");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "number",
      headerName: t("Number"),
      renderCell: (params) => (
        <EntityReferenceLink
          entityType="contract"
          entityId={params.row.id}
          label={params.row.number || "-"}
          canPreview={canViewContracts}
        />
      ),
    },
    {
        field: "start_date",
        headerName: t("Start Date"),
    },
    {
        field: "end_date",
        headerName: t("End Date"),
    },
    {
      field: "signature_date",
      headerName: t("Signature Date"),
      editable: false
    },
  ];

  const handleRowClick = (contractId: string) => {
    navigate(`/contracts/${contractId}`);
  };

  if (!canViewContracts) {
    return null;
  }

  const contractsUrl =`${CONTRACTS_ENDPOINT}?client=${id}`;

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<Handshake />}
        title={t('Contracts')}
        url={contractsUrl}
        gridSettingsKey="CLIENT_CONTRACTS"
        columns={columns}
        onRowClick={handleRowClick}
        refreshEventName="clientContractAdded"
      />
    </Box>
  );
};
